'use client';

export { default } from './Tab';
export { default as tabClasses } from './tabClasses';
export * from './tabClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Tab/index.js
// module id = 962
// module chunks = 25